module.exports = __webpack_public_path__ + "static/media/software.d14530c5.gif";